import { AlertTriangle, RotateCcw } from 'lucide-react';
import { useTheme } from '../theme/ThemeProvider';
import { Button } from './ui/Button';

/**
 * Tela mostrada quando o Sentry.ErrorBoundary captura um erro de render.
 *
 * Renderiza FORA do BrowserRouter (o boundary envolve o router em main.tsx), então
 * nada de <Link>/useNavigate aqui — navegação é via window.location mesmo.
 */
export function ErrorFallback({
  resetError,
  eventId,
}: {
  resetError?: () => void;
  eventId?: string;
}) {
  const { resolved } = useTheme();
  const icon = resolved === 'dark' ? '/faviconWhite.svg' : '/faviconBlack.svg';

  return (
    <div className="flex min-h-screen min-h-dvh flex-col items-center justify-center gap-6 px-6">
      <img src={icon} alt="OTG" className="size-20 object-contain" />

      <div className="flex flex-col items-center gap-3 text-center">
        <div className="flex size-14 items-center justify-center rounded-lg bg-brand-100 border border-brand-200/60 text-brand-600">
          <AlertTriangle className="size-6" />
        </div>
        <h1 className="text-base font-semibold text-ink">Algo deu errado</h1>
        <p className="max-w-sm text-sm text-ink-muted leading-relaxed">
          A tela travou por causa de um erro inesperado. O time já foi notificado
          automaticamente — recarregar costuma resolver.
        </p>
      </div>

      <div className="flex flex-wrap items-center justify-center gap-2">
        <Button leftIcon={<RotateCcw className="size-4" />} onClick={() => window.location.reload()}>
          Recarregar
        </Button>
        {resetError && (
          <Button variant="ghost" onClick={resetError}>
            Tentar de novo
          </Button>
        )}
      </div>

      {eventId && (
        <p className="text-xs text-ink-subtle">
          Código do erro: <span className="font-mono">{eventId}</span>
        </p>
      )}
    </div>
  );
}
